<template lang='pug'>
div
    div.fullwidth(v-if="$route.params.lang == 'en'")
        section.margin-bottom
            h1.secondary-header Product Overview
            //- h2 All Products of the BSS Hochspannungstechnik GmbH
        div.margin-bottom.category
            .category-title Multi-Sensor Partial Discharge Monitoring
            .column-container
                router-link.product(to='/en/products/pdm-600')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/PDM-600.webp')
                        img( src='@/assets/photos/product_shots/PDM-600.png', width="100%", alt='UHF PD Monitoring System PDM-600', title='UHF PD Monitoring System PDM-600')
                    div.overlay PDM-600
                    div.description Multi-Sensor PD Monitoring System
                router-link.product(to='/en/products/pdm-600-mobile')
                    picture
                        source(type='image/avif', srcset='@/assets/photos/product_shots/PDM-600-Mobile.avif')
                        source(type='image/webp', srcset='@/assets/photos/product_shots/PDM-600-Mobile.webp')
                        img( src='@/assets/photos/product_shots/PDM-600-Mobile.png', width="100%", alt='PD Monitoring System PDM-600-Mobile', title='UPD Monitoring System PDM-600-Mobile')
                    div.overlay PDM-600-Mobile
                    div.description Mobile Multi-Sensor PD Monitoring System
        div.margin-bottom.category
            .category-title Electrical Partial Discharge Monitoring
            .column-container
                router-link.product(to='/en/products/pdm-80')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/PDM-80.webp')
                        img( src='@/assets/photos/PDM-80.png', width="100%", alt='PD Monitoring System PDM-80', title='PD Monitoring System PDM-80')
                    div.overlay PDM-80
                    div.description Multiplexed Electrical PD Monitoring System
        div.margin-bottom.category
            .category-title UHF Partial Discharge Sensors
            .column-container
                router-link.product(to='/en/products/uhfsensors/uhf-ps1')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/UHF-PS1.webp')
                        img( src='@/assets/photos/product_shots/UHF-PS1.png', width="100%", alt='BSS UHF-PS1 Window-Type UHF Sensor', title='BSS UHF-PS1 Window-Type UHF Sensor')
                    div.overlay UHF-PS1
                    div.description Window-Type UHF PD Sensor
                router-link.product(to='/en/products/uhfsensors/uhf-dvs-50')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/for_product_overview/UHF-DVS-50.webp')
                        img( src='@/assets/photos/for_product_overview/UHF-DVS-50.png')
                    div.overlay UHF-DVS-50
                    div.description Drain Valve UHF PD Sensor for Retrofit at DN50/DN80 Oil Valves
                router-link.product(to='/en/products/uhfsensors/uhf-dvs-25')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/UHF-DVS-25.webp')
                        img( src='@/assets/photos/UHF-DVS-25.png')
                    div.overlay UHF-DVS-25
                    div.description Drain Valve UHF PD Sensor for Retrofit at DN25/DN40 Oil Valves
                router-link.product(to='/en/products/uhfsensors/uhf-ls-50')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/UHF-LS-50.webp')
                        img( src='@/assets/photos/UHF-LS-50.png')
                    div.overlay UHF-LS-50
                    div.description Standpipe UHF PD Sensor for Distribution-Level Transformers
        div.margin-bottom.category
            .category-title Electrical Partial Discharge Sensors
            .column-container
                router-link.product(to='/en/products/electricalpdsensors/zm3')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/ZM3.webp')
                        img( src='@/assets/photos/product_shots/ZM3.png', width="100%", alt='ZM3', title='ZM3')
                    div.overlay ZM3
                    div.description 3-Phase Coupling Device for IEC 60270 PD Measurement

                router-link.product(to='/en/products/electricalpdsensors/bs-pd')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/for_product_overview/BS-PD.webp')
                        img( src='@/assets/photos/for_product_overview/BS-PD.png')
                    div.overlay BS-PD
                    div.description PD & Bushing Monitoring Sensor for Test Taps
                router-link.product(to='/en/products/electricalpdsensors/hfct-50')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/for_product_overview/HFCT-50.webp')
                        img( src='@/assets/photos/for_product_overview/HFCT-50.png')
                    div.overlay HFCT-50
                    div.description Split-Core HFCT for Electrical PD Measurement
        div.margin-bottom.category
            .category-title Other Partial Discharge Sensors
            .column-container
                router-link.product(to='/en/products/otherpdsensors/ae-150-m')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/for_product_overview/AE-150-M.webp')
                        img( src='@/assets/photos/for_product_overview/AE-150-M.png')
                    div.overlay AE-150-M
                    div.description Acoustic PD Sensor
                router-link.product(to='/en/products/otherpdsensors/tev-cp')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/TEV-CP.webp')
                        img( src='@/assets/photos/TEVSensor.png')
                    div.overlay TEV-CP
                    div.description Transient Earth Voltage PD Sensor
        div.margin-bottom.category
            .category-title Signal Generators
            .column-container
                router-link.product(to='/en/products/cal-uhf')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/CAL-UHF-S.webp')
                        img( src='@/assets/photos/product_shots/CAL-UHF-S.png', width="100%", alt='BSS CAL-UHF Calibrator', title='UHF Reference Signal Generator CAL-UHF')
                    div.overlay CAL-UHF
                    div.description Calibrator for UHF PD Measurement
                router-link.product(to='/en/products/cal-iec')
                    picture
                        source(type='image/avif', srcset='@/assets/photos/product_shots/CAL-IEC-S.avif')
                        source(type='image/webp', srcset='@/assets/photos/product_shots/CAL-IEC-S.webp')
                        img( src='@/assets/photos/product_shots/CAL-IEC-S.png', width="100%", alt='BSS CAL-IEC Calibrator', title='PD Reference Signal Generator CAL-IEC')
                    div.overlay CAL-IEC
                    div.description Calibrator for electrical PD Measurement
                router-link.product(to='/en/products/hfig-600')
                    picture
                        source(type='image/avif', srcset='@/assets/photos/product_shots/HFIG-600.avif')
                        source(type='image/webp', srcset='@/assets/photos/product_shots/HFIG-600.webp')
                        img( src='@/assets/photos/product_shots/HFIG-600.png', width="100%", alt='BSS CAL-UHF Calibrator', title='UHF Reference Signal Generator CAL-UHF')
                    div.overlay HFIG-600
                    div.description Broadband VHF/UHF Pulse Generator
        div.margin-bottom.category
            .category-title Transformer Parts for Window-Type UHF PD Sensors
            .column-container
                router-link.product(to='/en/products/transformerparts/welding-ring-set')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/Welding_Ring_Set.webp')
                        img( src='@/assets/photos/product_shots/Welding_Ring_Set.png', width="100%", alt='Welding Ring Set', title='Welding Ring Set')
                    div.overlay Welding Ring Set
                    div.description Mounting Flange for Window-Type PD Sensors
                router-link.product(to='/en/products/transformerparts/dielectric-window-set')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/dielectric_window_set.webp')
                        img( src='@/assets/photos/product_shots/dielectric_window_set.png', width="100%", alt='Dielectric Window Set', title='Dielectric Window Set')
                    div.overlay Dielectric Window Set
                    div.description Oil Barrier for Window-Type PD Sensors
        div.margin-bottom.category
            .category-title Accessories & Other
            .column-container
                router-link.product(to='/en/products/pdaccessories/sensorcase')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/for_product_overview/SensorCase.webp')
                        img( src='@/assets/photos/for_product_overview/SensorCase.png')
                    div.overlay Sensor Case
                    div.description Robust Carrying Case for UHF Drain Valve Sensors
                router-link.product(to='/en/products/pdaccessories/flangeadapters')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/for_product_overview/FlangeAdapter.webp')
                        img( src='@/assets/photos/for_product_overview/FlangeAdapter.png')
                    div.overlay Flange Adapter
                    div.description Adapters for Drain Valves
                router-link.product(to='/en/products/pdaccessories/calibratorcase')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/for_product_overview/CAL-IEC-Case.webp')
                        img( src='@/assets/photos/for_product_overview/CAL-IEC-Case.png')
                    div.overlay CAL-IEC Accessory Kit
                    div.description Case, Cables, Clamps, and Connectors for the CAL-IEC
                router-link.product(to='/en/products/pdaccessories/cal-uhf-accessory-kit')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/CAL-UHF-Zubehörkoffer_transparent_Var1.webp')
                        img(src='@/assets/photos/product_shots/CAL-UHF-Zubehörkoffer_transparent_Var1.png', width='100%', alt='CAL-UHF Accessory Kit', title='CAL-UHF Accessory Kit')
                    div.overlay CAL-UHF Accessory Kit
                    div.description Case, cables, and adapters for the CAL-UHF
    div.fullwidth(v-if="$route.params.lang == 'de'")
        section.margin-bottom
            h1.secondary-header Produktübersicht
            //- h2.notopmargin Alle Produkte der BSS Hochspannungstechnik GmbH
        div.margin-bottom.category
            .category-title Multisensor-Teilentladungs-Monitoring 
            .column-container
                router-link.product(to='/de/products/pdm-600')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/PDM-600.webp')
                        img( src='@/assets/photos/product_shots/PDM-600.png', width="100%", alt='UHF PD Monitoring System PDM-600', title='UHF PD Monitoring System PDM-600')
                    div.overlay PDM-600
                    div.description Multisensor-TE-Monitoring-System
                router-link.product(to='/de/products/pdm-600-mobile')
                    picture
                        source(type='image/avif', srcset='@/assets/photos/product_shots/PDM-600-Mobile.avif')
                        source(type='image/webp', srcset='@/assets/photos/product_shots/PDM-600-Mobile.webp')
                        img( src='@/assets/photos/product_shots/PDM-600-Mobile.png', width="100%", alt='PD Monitoring System PDM-600-Mobile', title='UPD Monitoring System PDM-600-Mobile')
                    div.overlay PDM-600-Mobile
                    div.description Mobiles Multisensor-TE-Monitoring-System
        div.margin-bottom.category
            .category-title Elektrisches Teilentladungs-Monitoring
            .column-container
                router-link.product(to='/de/products/pdm-80')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/PDM-80.webp')
                        img( src='@/assets/photos/PDM-80.png', width="100%", alt='PD Monitoring System PDM-80', title='PD Monitoring System PDM-80')
                    div.overlay PDM-80
                    div.description Elektrisches Multiplex-TE-Monitoring-System
        div.margin-bottom.category
            .category-title UHF-Teilentladungssensoren
            .column-container
                router-link.product(to='/de/products/uhfsensors/uhf-ps1')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/UHF-PS1.webp')
                        img( src='@/assets/photos/product_shots/UHF-PS1.png', width="100%", alt='BSS UHF-PS1 Window-Type UHF Sensor', title='BSS UHF-PS1 Window-Type UHF Sensor')
                    div.overlay UHF-PS1
                    div.description UHF-TE-Fenstersensor
                router-link.product(to='/de/products/uhfsensors/uhf-dvs-50')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/for_product_overview/UHF-DVS-50.webp')
                        img( src='@/assets/photos/for_product_overview/UHF-DVS-50.png')
                    div.overlay UHF-DVS-50
                    div.description UHF-TE-Sensor für Nachrüstung an DN50/DN80 Ölschiebern
                router-link.product(to='/de/products/uhfsensors/uhf-dvs-25')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/UHF-DVS-25.webp')
                        img( src='@/assets/photos/UHF-DVS-25.png')
                    div.overlay UHF-DVS-25
                    div.description UHF-TE-Sensor für Nachrüstung an DN25/DN40 Ölschiebern
                router-link.product(to='/de/products/uhfsensors/uhf-ls-50')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/UHF-LS-50.webp')
                        img( src='@/assets/photos/UHF-LS-50.png')
                    div.overlay UHF-LS-50
                    div.description UHF-TE-Standrohrsensor für Verteiltransformatoren
        div.margin-bottom.category
            .category-title Elektrische Teilentladungssensoren 
            .column-container
                router-link.product(to='/de/products/electricalpdsensors/zm3')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/ZM3.webp')
                        img( src='@/assets/photos/product_shots/ZM3.png', width="100%", alt='ZM3', title='ZM3')
                    div.overlay ZM3
                    div.description 3-phasiger Ankoppelvierpol für IEC 60270 TE-Messung
                router-link.product(to='/de/products/electricalpdsensors/bs-pd')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/for_product_overview/BS-PD.webp')
                        img( src='@/assets/photos/for_product_overview/BS-PD.png')
                    div.overlay BS-PD
                    div.description TE- und Durchführungs-Monito-ring-Sensor für Messanschlüsse
                router-link.product(to='/de/products/electricalpdsensors/hfct-50')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/for_product_overview/HFCT-50.webp')
                        img( src='@/assets/photos/for_product_overview/HFCT-50.png')
                    div.overlay HFCT-50
                    div.description Split-Core-Stromwandler für elektrische TE-Messung
        div.margin-bottom.category
            .category-title Andere Teilentladungssensoren
            .column-container
                router-link.product(to='/de/products/otherpdsensors/ae-150-m')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/for_product_overview/AE-150-M.webp')
                        img( src='@/assets/photos/for_product_overview/AE-150-M.png')
                    div.overlay AE-150-M
                    div.description Akustischer TE-Sensor
                router-link.product(to='/de/products/otherpdsensors/tev-cp')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/TEV-CP.webp')
                        img( src='@/assets/photos/TEVSensor.png')
                    div.overlay TEV-CP
                    div.description Transient Earth Voltage TE-Sensor
        div.margin-bottom.category
            .category-title Signalgeneratoren
            .column-container
                router-link.product(to='/de/products/cal-uhf')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/CAL-UHF-S.webp')
                        img( src='@/assets/photos/product_shots/CAL-UHF-S.png', width="100%", alt='BSS CAL-UHF Calibrator', title='UHF Reference Signal Generator CAL-UHF')
                    div.overlay CAL-UHF
                    div.description Kalibrator für UHF-TE-Messung
                router-link.product(to='/de/products/cal-iec')
                    picture
                        source(type='image/avif', srcset='@/assets/photos/product_shots/CAL-IEC-S.avif')
                        source(type='image/webp', srcset='@/assets/photos/product_shots/CAL-IEC-S.webp')
                        img( src='@/assets/photos/product_shots/CAL-IEC-S.png', width="100%", alt='BSS CAL-IEC Calibrator', title='PD Reference Signal Generator CAL-IEC')
                    div.overlay CAL-IEC
                    div.description Kalibrator für elektrische TE-Messung

                router-link.product(to='/de/products/hfig-600')
                    picture
                        source(type='image/avif', srcset='@/assets/photos/product_shots/HFIG-600.avif')
                        source(type='image/webp', srcset='@/assets/photos/product_shots/HFIG-600.webp')
                        img( src='@/assets/photos/product_shots/HFIG-600.png', width="100%", alt='BSS CAL-UHF Calibrator', title='UHF Reference Signal Generator CAL-UHF')
                    div.overlay HFIG-600
                    div.description Breitband VHF/UHF Impulsgenerator
        div.margin-bottom.category
            .category-title Transformatorteile für UHF-Fenstersensoren
            .column-container
                router-link.product(to='/de/products/transformerparts/dielectric-window-set')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/dielectric_window_set.webp')
                        img( src='@/assets/photos/product_shots/dielectric_window_set.png', width="100%", alt='Dielectric Window Set', title='Dielectric Window Set')
                    div.overlay Dielektrisches Fenster Set
                    div.description Ölbarriere für UHF-Fenstersensoren
                router-link.product(to='/de/products/transformerparts/welding-ring-set')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/Welding_Ring_Set.webp')
                        img( src='@/assets/photos/product_shots/Welding_Ring_Set.png', width="100%", alt='Welding Ring Set', title='Welding Ring Set')
                    div.overlay Anschweißflansch Set
                    div.description Anschweißflansch für UHF-Fenstersensoren
        div.margin-bottom.category
            .category-title Zubehör & Weiteres
            .column-container
                router-link.product(to='/de/products/pdaccessories/sensorcase')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/for_product_overview/SensorCase.webp')
                        img( src='@/assets/photos/for_product_overview/SensorCase.png')
                    div.overlay Koffer für UHF-Sensoren
                    div.description Robuster Tragekoffer für UHF-Schiebesensoren
                router-link.product(to='/de/products/pdaccessories/flangeadapters')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/for_product_overview/FlangeAdapter.webp')
                        img( src='@/assets/photos/for_product_overview/FlangeAdapter.png')
                    div.overlay UHF-Flanschadapter
                    div.description Adaptierungen für Ölschieber
                router-link.product(to='/de/products/pdaccessories/calibratorcase')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/for_product_overview/CAL-IEC-Case.webp')
                        img( src='@/assets/photos/for_product_overview/CAL-IEC-Case.png')
                    div.overlay CAL-IEC Zubehörset
                    div.description Koffer, Kabel, Klemmen und Adapter für den CAL-IEC
                router-link.product(to='/de/products/pdaccessories/cal-uhf-accessory-kit')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/CAL-UHF-Zubehörkoffer_transparent_Var1.webp')
                        img(src='@/assets/photos/product_shots/CAL-UHF-Zubehörkoffer_transparent_Var1.png', width='100%', alt='CAL-UHF Zubehörset', title='CAL-UHF Zubehörset')
                    div.overlay CAL-UHF Zubehörset
                    div.description Koffer, Kabel und Adapter für den CAL-UHF
</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | Produkte",
            description: "Alle Produkte der BSS Hochspannungstechnik GmbH",
        },
        en: {
            title: "BSS | Products",
            description: "Range of Products provided by BSS Hochspannungstechnik GmbH",
        },
    },
};
</script>

<style lang='sass' scoped>
.category
    margin-bottom: 80px
    @media(max-width: $mobile-breakpoint)
        margin-bottom: 0
        width: 100%
    .category-title
        // color: darkgray
        font-weight: 400
        font-size: 1.2em
        margin-bottom: 10px
        margin-top: 20px

    .column-container
        flex-wrap: wrap
        row-gap: 20px
        align-items: stretch
        @media(max-width: $mobile-breakpoint)
            width: 100%
            flex-direction: row
            flex-wrap: wrap
            justify-content: space-between
        .product
            position: relative
            //height: 250px
            width: 230px
            margin-right: 20px
            // padding: 5px
            background-color: whitesmoke
            border-radius: 4px 4px 4px 4px
            @media(max-width: $mobile-breakpoint)
                width: 49%
                height: auto
                margin-bottom: 20px
                display: flex
                flex-direction: column
                align-items: center
                margin-right: 1px
            &:hover
                cursor: pointer
                background-color: lightgray
            &:hover .overlay
                display: block
                text-decoration: underline
            &:hover .description
                display: block
                background-color: lightgray
            img, picture
                padding: 5px
                height: 220px
                width: 220px
                aspect-ratio: 1 / 1
                object-fit: contain
                @media(max-width: $mobile-breakpoint)
                    height: auto
                    width: 100%

            .overlay
                background-color: $color3
                color: white
                padding: 3px 8px
                @media(max-width: $mobile-breakpoint)
                    display: block
                    width: 100%
                    position: relative
                    text-align: center
                    background-color: rgba(8,107,194,1)
                    padding: 5px
                    color: white

            .description
                background-color: whitesmoke
                border-radius: 0px 0px 4px 4px
                font-size: 0.8em
                word-wrap: break-word
                overflow-wrap: break-word
                white-space: normal
                padding: 8px
                @media(max-width: $mobile-breakpoint)
                    display: block
                    width: 100%
                    position: relative
                    text-align: center
                    bottom: 0
                    left: 0
                    right: 0
                    padding: 5px
</style>